import OutboundEmails from "../../clients/communication/OutboundEmails/OutboundEmails";

export default function SentEmailsWrapper() {
    return (
        <div className="v2-page">
            <OutboundEmails view="sent-emails" />
        </div>
    );
}
